<template>
    <b-overlay :show="showoverlay" rounded="sm" class="search-employee-overlay">
    <div class="card table-sorting-icons">
        <common-list :checkbox="checkbox" :is_action="is_action" :key="list_key" :appended_column="appended_column" :company_options="company_options" :employees="employees" :default_column="default_column" :primary_key="primary_key" :all_employee="all_employee"  v-on:childToParent="listReturn"></common-list>
    </div>
    </b-overlay>
</template>


<script>
    export default{
        props: ['flg'],        
        
        data(){
            return {
                cu:window.location.href,
                ce:false,
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                search_group:{name:'', email:'', phone:'' },
                search_by_id:{department_id:0, jobposition_id:0 , branch_id:0},
                //per_page:10,
                all_employee: 'yes',
                /**Child Component property data */
                checkbox:0, 
                is_action:0,
                list_key:0, 
                employees : [],                
                default_column:['name','phone','email','jobposition','department','branch'], 
                primary_key:'employee_id',
                company_options:[],
                appended_column:[],
                /***Child Component property data */

                notice: "No Result Found!",
                blankmsg : 'Fetching data..',
                people:0,

                showoverlay : true,
                
                depertments:[],
                jobtypes:[],
                branches:[],

                search:'',
                length: 10,
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
            }
        },
        methods:{            
            
            getEmployees: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;
                axios.get(this.$api_url+'/front/manager/elist' , {

                    }).then(function(response){
                        
                        this.showoverlay = false;
                        if(response.data.error == 1)
                            this.notice = response.data.notice;
                        else
                        {
                            this.employees = response.data.employee_data;
                            this.company_options = response.data.options;
                            this.list_key = this.list_key + 1;

                        }

                        }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
            },
            listReturn:function(data)
            {
                if(data.selected.length > 0)
                {
                    this.selected = data.selected;
                }
                else
                {
                    this.selected = [];
                    if(data.employee_id > 0)
                    {
                        this.editEmployee(data.employee_id,0);
                    }

                }
            },


            editEmployee:function(x)
            {    
                if(!this.checkNet()) return false;
                let formData = new FormData();
                formData.append('zombie', x);
                axios.post(this.$api_url+'/front/manager/sete', formData)
                    .then(function (response) 
                    {                                                                    
                        //window.location.href = this.$api_url+'/front/employee/info';
                        if(this.flg == 1)
                        {
                            //this.$forceUpdate();
                            let childdata = {employee_id:x};                    
                            this.$emit('childToParent', childdata);
                        }
                        else
                            location.reload(); 
                        
                    }.bind(this))
                    .catch(function (error) 
                    {
                        this.serverError(error);
                        this.errormsg = error.response.data.errors;
                    });

            },

        },
        created: function(){

            if(!this.checkNet()) return false;
            /*this.getDepertments();
            this.getJobTypes();
            this.getBranches();*/
            this.getEmployees();
            Fire.$on('reloadUsers', () => {this.getEmployees()})
        },
        computed: 
        {
            filteredData() 
            {
                let filtered_list = this.employees;
                if (this.search) 
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";                       
                }
                this.people = filtered_list.length;                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
<style>
button.disabled{
    cursor: default;
}

</style>
